import { NavLink } from 'react-router-dom'
import { Home, GraduationCap, Clock, CalendarDays, MoreHorizontal } from 'lucide-react'

const tabs = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/training', icon: GraduationCap, label: 'Training' },
  { to: '/checkin', icon: Clock, label: 'Time' },
  { to: '/attendance', icon: CalendarDays, label: 'Leave' },
  { to: '/more', icon: MoreHorizontal, label: 'More' },
]

export default function BottomTabBar() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {/* eslint-disable-next-line no-unused-vars */}
      {tabs.map(({ to, icon: TabIcon, label }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 py-2 px-3 text-xs transition-colors ${
              isActive ? 'text-emerald-600' : 'text-gray-400'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <TabIcon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
